export default function ExternalLink({ value, className = '', ...rest }) {
    return (
        <a
            target="_blank"
            rel="noreferrer"
            className={`no-underline text-(--link-soft)! hover:text-(--bg-color-default)! w-fit s-focus-ring ${className}`}
            {...rest}
        >
            {value}
        </a>
    )
}
